import JobStatsGrid, { type JobStatsItemProps } from "@components/ui/dashboard/JobStat"
import { getOfferStatistics } from "@services/api/offer/getStatistics/getStatistics";
import { useEffect, useState } from "react";

const JobStatsGridWrapper = () => {

    const [loading, setLoading] = useState<boolean>(true);
    const [statistic, setStatistic] = useState<JobStatsItemProps>({
        activeOpenings: 0,
        applications: 0,
        shortlisted: 0,
        questionAnswered: 0,
    });


    useEffect(() => {
        const fetchOfferStatistic = async () => {
            const response = await getOfferStatistics();
            setStatistic(response?.data);
            setLoading(false);
        };

        fetchOfferStatistic();
    }, []);

    return <JobStatsGrid loading={loading} item={statistic} />
}

export default JobStatsGridWrapper;